import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../../../../../components/CustomDate'
import FailedLoad from '../../../../../../../../../../../../../components/Workspace/components/FailedLoad'
import Money from '../../../../../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../../../../../constants'

import Suppliers from './components/Suppliers'

import hocConnect from './hocConnect'
import './styles.scss'

@injectIntl
@hocConnect
export default class Parts extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        dataLocale: PropTypes.string,
        failed: PropTypes.bool,
        id: PropTypes.string.isRequired,
        isLoading: PropTypes.bool,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        loadDetailsData: PropTypes.func.isRequired,
        loaded: PropTypes.bool,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        procurementParts: PropTypes.array,
        tenderId: PropTypes.number.isRequired,
        sorted: PropTypes.array,
        pagination: PropTypes.object,
    }

    componentDidMount() {
        const { loaded, dataLocale, locale, failed } = this.props

        if ((!loaded || dataLocale !== locale) && !failed) this.loadData()
    }

    componentDidUpdate(prevProps) {
        const { level } = this.props

        if (prevProps.level !== level) this.loadData()
    }

    loadData = () => {
        const { module, block, id, level, tenderId, loadDetailsData } = this.props

        loadDetailsData(module, block, id, level, tenderId)
    }

    handleTableChange = (changeData) => {
        const { module, block, id, level, loadTableData } = this.props

        loadTableData(module, block, id, level, changeData)
    }

    renderSubComponent = (rowData) => {
        const { module, block, id, level, locale, tenderId } = this.props
        const procurementSuppliers = rowData?.row?.original?.procurementSuppliers

        return (
            <Suppliers
                data={procurementSuppliers}
                module={module}
                block={block}
                id={id}
                level={level}
                locale={locale}
                tenderId={tenderId}
            />
        )
    }

    render() {
        const { procurementParts, id, tenderId, isLoading, failed, intl, pagination, sorted } = this.props

        // Failed data load
        if (failed && !isLoading) {
            return (
                <div className={'won-tenders-sub-table-wrapper'}>
                    <div className={'table-title'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.partsTableTitle` })}
                    </div>
                    <FailedLoad
                        customCallback={this.loadData}
                        customText={intl.formatMessage({ id: 'global.failedToLoadTabContent' })}
                        show={failed}
                    />
                </div>
            )
        }

        // Empty data
        if (_.isEmpty(procurementParts) && !isLoading && !failed) {
            return (
                <div className={'won-tenders-sub-table-wrapper'}>
                    <div className={'table-title'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.partsTableTitle` })}
                    </div>
                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.wonTenders.noData` })}
                </div>
            )
        }

        return (
            <div className={'won-tenders-sub-table-wrapper'}>
                <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.partsTableTitle` })}</div>
                <FilterTable
                    id={`won-tenders-parts-list-table-${id}-${tenderId}`}
                    itemIdentifier={'id'}
                    data={procurementParts || []}
                    loading={isLoading}
                    columnsDefinition={[
                        {
                            accessor: 'title',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.partName` }),
                            Cell: ({ value }) => <span title={value}>{value || '-'}</span>,
                        },
                        {
                            accessor: 'place',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.partPlace` }),
                            Cell: ({ value }) => <span title={value}>{value || '-'}</span>,
                        },
                        {
                            accessor: 'partValue',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.partValue` }),
                            Cell: ({ value }) => <Money value={value} emptyValue={'-'} showCurrency />,
                        },
                        {
                            accessor: 'fundedByEu',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.fundedByEu` }),
                            Cell: ({ value }) => (
                                <span>
                                    {value
                                        ? intl.formatMessage({ id: 'global.yes' })
                                        : intl.formatMessage({ id: 'global.no' })}
                                </span>
                            ),
                            width: 175,
                        },
                        {
                            accessor: 'dateRange.startDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.partDateFrom` }),
                            Cell: ({ value }) => <CustomDate date={value?.date} precision={value?.precision} />,
                            width: 150,
                        },
                        {
                            accessor: 'dateRange.endDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.partDateTo` }),
                            Cell: ({ value }) => <CustomDate date={value?.date} precision={value?.precision} />,
                            width: 150,
                        },
                    ]}
                    settings={{
                        pagination,
                        sorted,
                    }}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    expandOnRowClick
                    onTableChange={this.handleTableChange}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                />
            </div>
        )
    }
}
